import { render, staticRenderFns } from "./InformeDetalleViaje.vue?vue&type=template&id=7075151e&scoped=true&"
import script from "./InformeDetalleViaje.vue?vue&type=script&lang=ts&"
export * from "./InformeDetalleViaje.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7075151e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7075151e', component.options)
    } else {
      api.reload('7075151e', component.options)
    }
    module.hot.accept("./InformeDetalleViaje.vue?vue&type=template&id=7075151e&scoped=true&", function () {
      api.rerender('7075151e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ProgramacionInforme/TiposdeInformes/TipoDetalleViaje/InformeDetalleViaje.vue"
export default component.exports